import { createSelector } from 'reselect';
import { pathOr } from 'ramda';
import { RouteParams, SelectedCustomerSelector } from './customer.selectors';
import { ContextOfferingAction } from '../constants/wizard.constants';
import { DEFAULT_OFFER_REMAINING, DEFAULT_REMOVE_ITEM_REMAINING_AMOUNTS } from '../constants/offering.remove.constants';
export var RemoveOfferItemsIdsSelector = createSelector([RouteParams], function (routeParams) {
  return routeParams.offeringId && routeParams.offeringInstanceId ? [{
    offeringId: routeParams.offeringId,
    offeringInstanceId: routeParams.offeringInstanceId
  }] : null;
});
export var RemoveOfferItemsRequestSelector = createSelector([RemoveOfferItemsIdsSelector], function (removeOfferingIds) {
  var data = {};
  if (removeOfferingIds) {
    data.Offerings = removeOfferingIds.map(function (removeOffering) {
      return {
        Action: ContextOfferingAction.REMOVE,
        OfferingId: removeOffering.offeringId,
        OfferingInstanceId: removeOffering.offeringInstanceId
      };
    });
  }
  data.RetrievePaymentInstrument = true;
  return data;
});
export var RemoveItemsSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  var items = [];
  if (selectedCustomer.removeOffering.data.removeItems) {
    selectedCustomer.removeOffering.data.removeItems.forEach(function (item) {
      var temp = Object.assign({}, item.asMutable({
        deep: true
      }));
      if (item.OrderContractInstance) {
        temp.OrderContractInstance.EffectiveEndDate = new Date().toISOString();
      }
      items.push(temp);
    });
  }
  return items;
});
export var RemoveItemsTotalAmountSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(null, ['removeOffering', 'data', 'removeItemsTotalAmount'], selectedCustomer);
});
export var RemoveItemsPaymentInstrumentSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(null, ['removeOffering', 'data', 'paymentInstrument'], selectedCustomer);
});
export var RemoveItemsHasContractEndSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return !!selectedCustomer.removeOffering.data.contractEnd;
});
var DEFAULT_FIRST_ITEM = {};
export var FirstRemoveItemsSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(DEFAULT_FIRST_ITEM, ['removeOffering', 'data', 'removeItems', 0], selectedCustomer);
});
export var CurrencySelector = createSelector([RouteParams], function (routeParams) {
  return routeParams.currency ? routeParams.currency : null;
});
export var OfferingNameSelector = createSelector([FirstRemoveItemsSelector], function (firstRemoveItem) {
  return firstRemoveItem && firstRemoveItem.OrderedOfferingName ? firstRemoveItem.OrderedOfferingName : null;
});
export var QuoteOfferSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.removeOffering ? selectedCustomer.removeOffering.quote : null;
});
export var QuoteOfferRemoveItemRemainingAmountsSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(DEFAULT_REMOVE_ITEM_REMAINING_AMOUNTS, ['removeOffering', 'removeItemRemainingAmounts'], selectedCustomer);
});
export var RemoveItemsRemainingAmountSelector = createSelector([SelectedCustomerSelector, QuoteOfferRemoveItemRemainingAmountsSelector], function (selectedCustomer, remainingAmounts) {
  var items = [];
  if (selectedCustomer.removeOffering.data.removeItems) {
    selectedCustomer.removeOffering.data.removeItems.forEach(function (item) {
      var temp = Object.assign({}, item.asMutable({
        deep: true
      }));
      if (item.OrderContractInstance) {
        temp.OrderContractInstance.EffectiveEndDate = new Date().toISOString();
      }
      var amount = remainingAmounts.find(function (amount) {
        return item.LockerItemId === amount.SubscriberProductId && item.OrderedOfferingId === amount.OfferingId;
      });
      if (amount && amount.RemainingAmount) {
        temp.Details.RemainingAmount = amount.RemainingAmount;
      }
      items.push(temp);
    });
  }
  return items;
});
export var QuoteOfferRemainingAmountSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(DEFAULT_OFFER_REMAINING, ['removeOffering', 'totalRemainingAmount'], selectedCustomer);
});
export var IsCalculatingQuoteSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.removeOffering ? selectedCustomer.removeOffering.isCalculatingQuote : null;
});
export var IsSubmittingOrderSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.removeOffering && selectedCustomer.removeOffering.isSubmittingOrder;
});
export var LastAttemptErrorSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.removeOffering && selectedCustomer.removeOffering.lastAttemptError;
});
export var FirstOfferingIdSelector = createSelector([RemoveOfferItemsRequestSelector], function (offeringsArray) {
  return pathOr(null, ['Offerings', 0, 'OfferingId'], offeringsArray);
});